// extracted by mini-css-extract-plugin
module.exports = {"card":"hero-card_card__y1r1s","card__content":"hero-card_card__content__ZK30q","card__list":"hero-card_card__list__aINBm","card__img":"hero-card_card__img__J0s4a"};